module.exports = __webpack_public_path__ + "resources/remove-b83180e35e714c3c7a50033af97a6659.svg";